export const figure18f = {
  chart: {
      type: 'line',
      backgroundColor: 'rgba(255, 255, 255, 0.0)',
        height: 230,
      plotBackgroundColor: null,
      plotBorderWidth: null,
    },
    credits: {
      enabled: false
  },
    title: {
      text: 'Pérou'
    },
    subtitle: {
      text: null
  },
    xAxis: {
      categories: ['2010','2014','2015', '2017', '2018','2019',]
    },
    labels: {
      	      style: {
        fontWeight: 'normal',
        color: '#999999',
        fontSize: '12px'
      },
    },
    yAxis: {
      min: 0,
      max: 4000,
      tickInterval: 1000,
      title: {
          text: null,
      },
    },
    plotOptions: {
      line: {
        dataLabels: {
          enabled: false
        },
        enableMouseTracking: true
      }
    },
    legend: {
      enabled: false,
  },
    colors: ['#5b9bd5', '#ed7d32','#cbcccb', '#ffc100'],
    series: [{
      name: 'Petites exploitations',
      data: [1656, 1715, 1738, 1593, 1656, 1779,]
    }, {
      name: 'Autres exploitations',
      data: [3327, 3256, 3223, 2729, 2870, 3099,]
    },{
      name: 'Petites exploitations dirigées par une femme',
      data: [1195, 1244, 1260, 1082, 1187, 1192,]
    },{
      name: 'Petites exploitations dirigées par un homme',
      data: [1784, 1865, 1888, 1758, 1816, 1996,]
    }]
  }

  